import React from 'react';
import BingMapsReact from 'bingmaps-react';


// eslint-disable-next-line no-unused-vars
const Map = ({ location }) => {
	// 53.0378562, -1.2188887
	// 53.03818997382253, -1.2182791919306584;
	// 53.03816534226703, -1.2182832658158829
	const latitude = 53.03816534226703;
	const longitude = -1.2182832658158829;
	const pushPin = {
		center: {
			latitude,
			longitude
		},
		options: {
			title: 'Hucknall Timber',
		},
	};

	const pushPins = [pushPin];

	return (
		<BingMapsReact
			pushPins={pushPins}
			viewOptions={{
				center: { latitude, longitude },
				zoom: 17,
			}}
			bingMapsKey="AtLNdz2rhphRf5Xn600NZNEKWiqMIMLpZIL5Tn37XcQgiC7HHJQjnhBRCtRwJkoD"
		/>
	);
};

export default Map;
